module.exports = __webpack_public_path__ + "static/media/0025_IMG_LES_MURS_CHROMATIC_CH2_1006.b89e7749.webp";